const renders = new WeakMap();

/** cm-chessboard updates its model before the animation promise resolves. */
export function trackPositionRendering(board, onReady) {
    if (!board || renders.has(board)) return;
    const state = { revision: 0, pending: 0, failed: false };
    renders.set(board, state);
    const setPosition = board.setPosition.bind(board);
    board.setPosition = (fen, animated) => {
        const revision = ++state.revision;
        ++state.pending;
        const finish = failed => {
            --state.pending;
            if (failed) state.failed = true;
            else if (revision === state.revision) state.failed = false;
            // An identical-placement update can resolve immediately while older
            // animations are queued. Wait for the whole queue, not just its newest call.
            if (state.pending === 0 && !state.failed) onReady();
        };
        let result;
        try { result = setPosition(fen, animated); }
        catch (error) { finish(true); throw error; }
        if (result?.then) {
            // Failed renders remain unavailable for search until a successful update.
            return result.then(value => { finish(false); return value; }, () => { finish(true); return false; });
        }
        finish(false);
        return result;
    };
}

export function isPositionRendering(board) {
    const state = renders.get(board);
    return Boolean(state && (state.pending > 0 || state.failed));
}
